exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-privacy-tsx": () => import("./../../../src/pages/privacy.tsx" /* webpackChunkName: "component---src-pages-privacy-tsx" */),
  "component---src-pages-refunds-tsx": () => import("./../../../src/pages/refunds.tsx" /* webpackChunkName: "component---src-pages-refunds-tsx" */),
  "component---src-pages-terms-tsx": () => import("./../../../src/pages/terms.tsx" /* webpackChunkName: "component---src-pages-terms-tsx" */),
  "component---src-pages-uninstall-tsx": () => import("./../../../src/pages/uninstall.tsx" /* webpackChunkName: "component---src-pages-uninstall-tsx" */)
}

